import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import AuditLogs from '../AuditLogs';
import FunctionsList from '../FunctionsList';
import WmReactTable from '../Layout/WmReactTable';
export default class AuditLogModal extends Component {
  constructor(props) {
    super(props);
    this.getData = async () => {
      const apiOptions = {
        auth: this.props.auth,
        listApi: "audit_logs?item_type=".concat(this.props.modelType, "&item_uuid=").concat(this.props.modelUuid)
      };
      const data = await FunctionsList.fetchData(apiOptions);
      this.setState({
        data: data.data,
        loading: false
      });
    };
    // TODO: Translate Line 36
    this.render = () => /*#__PURE__*/React.createElement(Modal, {
      className: "otto__modal-l",
      isOpen: this.props.showModal,
      toggle: this.props.closeModal,
      backdrop: "static"
    }, /*#__PURE__*/React.createElement(ModalHeader, {
      toggle: this.props.closeModal
    }, "Audit Log", ' ', this.props.afterTitle), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(WmReactTable, {
      data: this.state.data,
      columns: AuditLogs(this),
      sortBy: [{
        id: 'id',
        desc: true
      }]
    })));
    this.state = {
      loading: true,
      data: []
    };
  }
  async componentDidMount() {
    await this.getData();
  }
}